import { useNavigate } from "react-router-dom";
import { Spinner, Button } from "react-bootstrap";
import React, { useRef } from "react";
import { useAuthContext } from "../../hooks";
import Images from "../../Assets/xbi4-logo.png";
import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { LoginSc } from "./index.sc";
import "./style.css";
import { turnOnDbInstance } from "../../api/Admin/turnOnDbInstance";
export default function Login() {
  const auth = useAuthContext();
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [isDbTurningOn, setIsDbTurningOn] = useState(false);
  const onSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Login attempt started");
    
    auth
      ?.signIn(usernameRef?.current?.value, passwordRef?.current?.value)
      .then(async (res: any) => {
        console.log("Login response:", res);
        console.log("Response statusCode:", res?.statusCode);
        console.log("Response redirectTo:", res?.redirectTo);
        
        if (!res || res.statusCode === 400) {
          console.log(res?.message?.info || "Something Went wrong");
        } else if (res?.redirectTo) {
          console.log("Starting database turn-on process...");
          // Turn on database instance after successful sign-in
          setIsDbTurningOn(true);
          try {
            const dbResult = await turnOnDbInstance();
            console.log("Database instance turned on successfully:", dbResult);
          } catch (error) {
            console.error("Failed to turn on database instance:", error);
          } finally {
            setIsDbTurningOn(false);
            navigate(res?.redirectTo);
          }
        } else {
          console.log("No redirectTo found in response, database not started");
        }
      })
      .catch((error:any) => {
        console.error("Login error:", error);
      });
  };
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  useEffect(() => {
    if (password.length < 8) {
      setPasswordError("Password should be 8 characters");
    } else {
      setPasswordError("");
    }
  }, [password]);
  const handlePasswordChange = (event: any) => {
    setPassword(event.target.value);
  };
  const initialValues = { email: "", password: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState(initialValues);
  function handleChange(e: any) {
    const { name, value } = e.target;
    const tempValues = { ...formValues, [name]: value };
    setFormValues(tempValues);
  }

  return !auth?.isAuthenticating ? (
    <div className="login-page">
      <img src={Images} className="xbi4-image" />
      <div className="login-container-auth">
        <form onSubmit={onSubmit}>
          <label htmlFor="username">Email Address</label>

          <input
            type="email"
            className="inputs"
            id="username"
            placeholder="Enter email"
            ref={usernameRef}
            onChange={handleChange}
          />

          <label htmlFor="password">Password</label>
          <div className="login-password">
            <input
              type={showPassword ? "" : "password"}
              className=""
              id="password"
              placeholder="Password"
              value={password}
              ref={passwordRef}
              onChange={handlePasswordChange}
            />
            <button
              type="button"
              className="eyePassword"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaEyeSlash
                  style={{
                    width: "35px",
                  }}
                />
              ) : (
                <FaEye
                  style={{
                    width: "35px",
                  }}
                />
              )}
            </button>
          </div>
          <div className="login-button-main">
            <button className="login-button" type="submit">
              <span>Login</span>
            </button>
          </div>
        </form>
        <div
          className="forget-password"
          onClick={() => navigate("/forgetPassword")}
          style={{ cursor: "pointer" }}
        >
          Forgot Password
        </div>
      </div>
    </div>
  ) : (
    <div className=" d-flex flex-column min-vh-100 min-vw-100">
      <div className=" d-flex flex-grow-1 justify-content-center align-items-center ">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </div>
  );
}
